const getAvailableVoices = () =>
    new Promise((resolve) => {
        const voices =
            window.speechSynthesis.getVoices();

        if (voices.length > 0) {
            resolve(voices);
            return;
        }

        const handleVoicesChanged = () => {
            const loadedVoices =
                window.speechSynthesis.getVoices();

            window.speechSynthesis.removeEventListener(
                'voiceschanged',
                handleVoicesChanged
            );

            resolve(loadedVoices);
        };

        window.speechSynthesis.addEventListener(
            'voiceschanged',
            handleVoicesChanged
        );
    });

const getPreferredVoice = (
    voices,
    speechLocale
) => {

    const voicePriority = [
        // Windows Natural Voices
        'Microsoft Aria',
        'Microsoft Jenny',
        'Microsoft Guy',

        // Apple
        'Samantha',

        // Android / Chrome
        'Google US English',

        // Additional good quality voices
        'Karen',
        'Moira',
        'Daniel'
    ];

    for (const preferredName of voicePriority) {
        const matchingVoice =
            voices.find((voice) =>
                voice.name.includes(
                    preferredName
                )
            );

        if (matchingVoice) {
            return matchingVoice;
        }
    }

    return (
        voices.find(
            (voice) =>
                voice.lang ===
                    speechLocale &&
                voice.default
        ) ||
        voices.find(
            (voice) =>
                voice.lang ===
                speechLocale
        ) ||
        null
    );
};

export const webSpeechEngine = async (
    text,
    speechLocale = 'en-US'
) => {

    if (!text?.trim()) {
        return;
    }

    const synth =
        window.speechSynthesis;

    try {
        const voices =
            await getAvailableVoices();

        const selectedVoice =
            getPreferredVoice(
                voices,
                speechLocale
            );

        const utterance =
            new SpeechSynthesisUtterance(
                text
            );

        if (selectedVoice) {
            utterance.voice =
                selectedVoice;
        }

        utterance.lang =
            speechLocale;

        utterance.rate = 1;
        utterance.pitch = 1;
        utterance.volume = 1;


        utterance.onerror = (
            event
        ) => {

            if (
                event?.error ===
                'canceled'
            ) {
                return;
            }

            console.error(
                'WEB SPEECH ERROR',
                event
            );
        };

        synth.speak(utterance);

    } catch (error) {

        console.error(
            'Web Speech initialization error',
            error
        );

    }
};